module.exports = __webpack_public_path__ + "img/note.5f14b049.svg";